export default __webpack_public_path__ + "static/media/icon-wallet-connect.5642eca7.svg";